import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { BadgeCheck, Copy, AlertTriangle } from 'lucide-react';

const B = process.env.REACT_APP_BACKEND_URL;
let cached = null;

const useOfficialAddress = () => {
  const [a, setA] = useState(cached);
  useEffect(() => {
    if (cached) return;
    axios.get(`${B}/api/token-list/beth-usd.json`).then(r => { cached = r.data.tokens[0].address; setA(cached); }).catch(() => {});
  }, []);
  return a;
};

export const OfficialToken = ({ compact = false }) => {
  const addr = useOfficialAddress();
  if (!addr) return null;
  const copy = () => navigator.clipboard.writeText(addr).then(() => toast.success('Official address copied')).catch(() => {});
  return (
    <div className={`border border-emerald-500/40 bg-emerald-950/40 rounded-xl ${compact ? 'p-3' : 'p-4'} space-y-1.5`} data-testid="official-token">
      <p className="text-xs text-emerald-300 font-semibold flex items-center gap-1.5"><BadgeCheck className="w-4 h-4" /> Official BETH USD · Base network</p>
      <button onClick={copy} className="w-full text-left font-mono text-[11px] text-white break-all hover:text-emerald-300 transition-colors flex items-start gap-1.5" data-testid="official-token-address">
        {addr} <Copy className="w-3 h-3 mt-0.5 shrink-0" />
      </button>
      <p className="text-[10px] text-amber-300/90 flex items-start gap-1"><AlertTriangle className="w-3 h-3 mt-0.5 shrink-0" /> Look-alike "Bethcoin"/"BETH" tokens exist. Only this address, starting 0x090da15F, is BETH USD.</p>
    </div>
  );
};
